module.exports = __webpack_public_path__ + "prj_03.68fd0095.jpeg";